import { ViewListIcon } from "@heroicons/react/outline";
import classNames from "classnames";
import { useCallback, useState } from "react";

import { useCanSeeFrontEndAdmin } from "shared/hooks/usePermissions";
import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { useAppSelector } from "app/hooks";

const ContextMenu = ({
  type,
  id,
  caseId,
}: {
  type: "Specimen" | "Block" | "Slide" | "Order" | "Work" | "Task";
  id: number;
  caseId: number;
}) => {
  const canSeeAdmin = useCanSeeFrontEndAdmin();
  const djangoAdminLink = useAppSelector((state) =>
    selectFeatureFlag(state, "djangoAdminLink")
  );

  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);

  const toggleOpen = useCallback(() => {
    if (!open) {
      document.addEventListener("click", close, { once: true });
    } else {
      document.removeEventListener("click", close);
    }
    setOpen(!open);
  }, [open]);

  const {
    REACT_APP_QC_ADMIN_DOMAIN,
    REACT_APP_BACKEND_PROTOCOL,
    REACT_APP_BACKEND_HOST,
    REACT_APP_BACKEND_PORT,
    REACT_APP_ADMIN_SUFFIX,
  } = process.env;

  let qcAdminUrl = REACT_APP_QC_ADMIN_DOMAIN;
  let djangoAdminUrl = `${REACT_APP_BACKEND_PROTOCOL}://${REACT_APP_BACKEND_HOST}:${REACT_APP_BACKEND_PORT}/${REACT_APP_ADMIN_SUFFIX}`;

  if (type === "Specimen") {
    qcAdminUrl += `cases/${caseId}/specimens/${id}/`;
    djangoAdminUrl += `histoslide/specimen/${id}/change/`;
  } else if (type === "Block") {
    qcAdminUrl = "";
    djangoAdminUrl += `histoslide/block/${id}/change/`;
  } else if (type === "Slide") {
    qcAdminUrl += `cases/${caseId}/slides/${id}/`;
    djangoAdminUrl += `histoslide/slide/${id}/change/`;
  } else if (type === "Order") {
    qcAdminUrl = "";
    djangoAdminUrl += `lab/laborder/${id}/change/`;
  } else if (type === "Work") {
    qcAdminUrl = "";
    djangoAdminUrl += `lis/workprocess/${id}/change/`;
  } else {
    qcAdminUrl = "";
    djangoAdminUrl = "";
  }

  if (!(canSeeAdmin && qcAdminUrl) && !(djangoAdminLink && djangoAdminUrl))
    return null;

  return (
    <span className="ContextMenu" onClick={(event) => event.stopPropagation()}>
      <button className="ContextMenu--toggle" onClick={toggleOpen}>
        <ViewListIcon />
      </button>
      <div className={classNames("ContextMenu--menu", { open })}>
        <ul>
          {canSeeAdmin && !!qcAdminUrl && (
            <li>
              <a href={qcAdminUrl} target="_blank" rel="noreferrer">
                QC Admin
              </a>
            </li>
          )}
          {djangoAdminLink && !!djangoAdminUrl && (
            <li>
              <a href={djangoAdminUrl} target="_blank" rel="noreferrer">
                Django Admin
              </a>
            </li>
          )}
        </ul>
      </div>
    </span>
  );
};

export default ContextMenu;
